import { lazy, Suspense } from 'react'
import DashboardLayout from '../layouts/Dashboard'
import AuthGuard from '../components/guards/AuthGuard'
import { UserRole } from '../enums'
import LoadingState from '../components/LoadingState'

const Blueprint = lazy(() => import('../pages/pages/Blueprint'))

export default [
  {
    path: '/blueprint/project/:projectId/level/:levelId',
    element: (
      <AuthGuard roles={[UserRole.SUPERADMIN, UserRole.ADMIN, UserRole.USER, UserRole.INSTALLER]}>
        <DashboardLayout>
          <Suspense fallback={<LoadingState align="center" />}>
            <Blueprint />
          </Suspense>
        </DashboardLayout>
      </AuthGuard>
    )
  }
]
